import Wrapper from "../../../layout/Wrapper";
import PoliciesManageComponent from "../../../screens/settings/policies/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Policies Management",
	description: "",
};

export default function PoliciesManagement() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<PoliciesManageComponent />
		</Wrapper>
	);
}